export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? 'dev-8kcy7efpxaoy38vg.us.auth0.com';
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? '3Fcx1cI4wZgVm4Mia0fWWyvOKabAHZSd';
export const API_URL = process.env.REACT_APP_API_URL ?? 'https://localhost:8000';
export const AUTH0_API_AUDIENCE_NAME = process.env.REACT_APP_API_URL ?? 'https://api-dev.ensis.ai';
export const SENTRY_DSN = 'https://f6f011c3ec976610d7f043fa2a5a6b72@o4506339732946944' +
  '.ingest.sentry.io/4506419520536576';

export type EnvType = 'dev' | 'local' | 'qa' | 'staging' | 'prod' | 'tria';
export const DEPLOYMENT_ENV: EnvType = process.env.REACT_APP_DEPLOY_ENV?.toLowerCase() as EnvType ?? 'local';
